import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import IconButton from "../Buttons/IconButton";
import { PRIMARY_COLOR_TEXT } from "../../utils/colors";
import {
  galleryPublishButtonSx,
  getGallerySecondaryLabeledButtonSx,
  mergeGalleryLiquidGlassSx,
} from "./galleryIconButtonStyles";

const GALLERY_LABELED_ACTION_VARIANT = {
  secondary: "secondary",
  primary: "primary",
};

const GalleryLabeledActionButton = ({
  variant = GALLERY_LABELED_ACTION_VARIANT.secondary,
  label,
  icon: Icon = null,
  onClick,
  loading = false,
  disabled = false,
  className,
  labelSx = {},
  sx: sxProp = {},
  useLiquidGlass = false,
  // "generate" keeps its own optical alignment without affecting Launch ad / Post
  liquidGlassLabelAlign = "default",
}) => {
  const theme = useTheme();
  const isPrimary = variant === GALLERY_LABELED_ACTION_VARIANT.primary;
  const isGenerateLiquidGlassLabel =
    useLiquidGlass && liquidGlassLabelAlign === "generate";

  const baseSx = isPrimary
    ? { ...galleryPublishButtonSx, flexShrink: 0 }
    : getGallerySecondaryLabeledButtonSx(theme);

  const liquidGlassBaseSx = {
    ...getGallerySecondaryLabeledButtonSx(theme),
    flexShrink: 0,
  };

  const sx = useLiquidGlass
    ? mergeGalleryLiquidGlassSx({
        baseSx: { ...liquidGlassBaseSx, ...sxProp },
      })
    : { ...baseSx, ...sxProp };

  const labelColor = useLiquidGlass
    ? PRIMARY_COLOR_TEXT
    : isPrimary
      ? "#fff"
      : PRIMARY_COLOR_TEXT;

  return (
    <IconButton
      onClick={onClick}
      className={className}
      disabled={disabled}
      loading={loading}
      loaderColor={useLiquidGlass || !isPrimary ? PRIMARY_COLOR_TEXT : "white"}
      aria-label={label}
      sx={sx}
      size="small"
      edge={false}
    >
      {useLiquidGlass ? (
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            height: 32,
            lineHeight: 1,
            fontWeight: 700,
            fontSize: "0.72rem",
            color: labelColor,
            whiteSpace: "nowrap",
            ...labelSx,
            // Generate: no translate — keep Launch ad / Post optical nudge
            ...(!isGenerateLiquidGlassLabel
              ? { transform: "translateY(0.5px)" }
              : {}),
          }}
        >
          {label}
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: Icon ? 0.5 : 0,
            whiteSpace: "nowrap",
          }}
        >
          {Icon ? (
            isPrimary ? (
              <Icon size={16} color="white" />
            ) : (
              <Icon
                sx={{
                  color: PRIMARY_COLOR_TEXT,
                  fill: PRIMARY_COLOR_TEXT,
                }}
              />
            )
          ) : null}
          <Typography
            variant="caption"
            component="span"
            sx={{
              color: labelColor,
              fontWeight: 700,
              fontSize: "0.72rem",
              pt: Icon && !isPrimary ? 0.2 : 0,
              lineHeight: 1,
              ...labelSx,
            }}
          >
            {label}
          </Typography>
        </Box>
      )}
    </IconButton>
  );
};

export default GalleryLabeledActionButton;
